"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "motion/react";
import type { ProjectDetail } from "@/types/projects";
import { ProjectCard } from "@/ui/project-cards/card";
export function ProjectGrid(t0) {
  const $ = _c(4);
  const {
    projects
  } = t0;
  let t1;
  if ($[0] !== projects) {
    t1 = projects.map(_temp);
    $[0] = projects;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="container px-6 max-w-screen grid grid-cols-1 gap-y-16 lg:grid-cols-2 lg:gap-x-8">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(project, index) {
  return <motion.div key={project.id} initial={{
    opacity: 0,
    y: 50
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className={`${index % 2 === 0 ? "md:mt-24" : ""}`}><ProjectCard project={project} /></motion.div>;
}